var _style, _path, _defs, _defs2, _circle, _circle2, _circle3, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _circle4, _circle5, _circle6, _path12, _path13, _g, _path14, _g2, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMusicalEncountersFinal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#D9D5E5;}\n\t.st1{clip-path:url(#SVGID_00000054965348396176328100000006981260911141175976_);}\n\t\n\t\t.st2{clip-path:url(#SVGID_00000011014035848461647710000008341121039850774961_);fill:url(#SVGID_00000106132207140194349950000017895327815573321370_);}\n\t.st3{opacity:5.000000e-02;clip-path:url(#SVGID_00000011014035848461647710000008341121039850774961_);fill:#B5DCE5;}\n\t\n\t\t.st4{clip-path:url(#SVGID_00000011014035848461647710000008341121039850774961_);fill:url(#SVGID_00000079474240824947006360000005565155227863096500_);}\n\t\n\t\t.st5{clip-path:url(#SVGID_00000011014035848461647710000008341121039850774961_);fill:url(#SVGID_00000138532645662339101440000017724600656021354880_);}\n\t.st6{clip-path:url(#SVGID_00000011014035848461647710000008341121039850774961_);}\n\t.st7{fill:url(#SVGID_00000046325662344158666010000001343328375521583024_);}\n\t.st8{fill:#B5DCE5;}\n\t\n\t\t.st9{clip-path:url(#SVGID_00000054965348396176328100000006981260911141175976_);fill:none;stroke:url(#SVGID_00000011732734133951912660000004655786478759199153_);stroke-width:0.5;stroke-miterlimit:10;}\n\t\n\t\t.st10{clip-path:url(#SVGID_00000054965348396176328100000006981260911141175976_);fill:none;stroke:url(#SVGID_00000038385796392730763750000014241042223165884569_);stroke-width:0.5;stroke-miterlimit:10;}\n\t\n\t\t.st11{clip-path:url(#SVGID_00000054965348396176328100000006981260911141175976_);fill:none;stroke:url(#SVGID_00000035494451251617917590000013181578052184907156_);stroke-width:0.5;stroke-miterlimit:10;}\n\t\n\t\t.st12{clip-path:url(#SVGID_00000054965348396176328100000006981260911141175976_);fill:none;stroke:url(#SVGID_00000183243481453139796350000002082626818254035865_);stroke-width:0.5;stroke-miterlimit:10;}\n\t\n\t\t.st13{clip-path:url(#SVGID_00000054965348396176328100000006981260911141175976_);fill:none;stroke:url(#SVGID_00000065050249060982216630000004584263141765951420_);stroke-width:0.5;stroke-miterlimit:10;}\n\t\n\t\t.st14{clip-path:url(#SVGID_00000054965348396176328100000006981260911141175976_);fill:none;stroke:url(#SVGID_00000075869753509162428040000016083333002945989300_);stroke-width:0.5;stroke-miterlimit:10;}\n\t\n\t\t.st15{clip-path:url(#SVGID_00000054965348396176328100000006981260911141175976_);fill:none;stroke:url(#SVGID_00000011734150480887866170000003376380940543383440_);stroke-width:0.5;stroke-miterlimit:10;}\n\t\n\t\t.st16{clip-path:url(#SVGID_00000054965348396176328100000006981260911141175976_);fill:none;stroke:url(#SVGID_00000031890370905683391780000015698271396636146596_);stroke-width:0.5;stroke-miterlimit:10;}\n\t.st17{fill:url(#SVGID_00000119118801196834598070000014061448397293478064_);}\n\t.st18{fill:url(#SVGID_00000108309384993951069230000000933189798884313739_);}\n\t.st19{fill:#42210B;}\n\t.st20{fill:url(#SVGID_00000164495944909593284370000013609526090198490256_);}\n\t.st21{fill:#010621;}\n\t.st22{fill:#B8140F;}\n\t.st23{fill:#1E1517;}\n\t.st24{fill:url(#SVGID_00000007413932964642180900000016596945453713456573_);}\n\t.st25{fill:url(#SVGID_00000111873539771259933600000008781826104706448028_);}\n\t.st26{fill:url(#SVGID_00000054263570662230937590000013686884579356439997_);}\n\t.st27{fill:url(#SVGID_00000065774715878333435880000004652236323704431745_);}\n\t.st28{fill:url(#SVGID_00000060745116719482643230000018047450138836286080_);}\n\t.st29{fill:url(#SVGID_00000121976401760253747550000009922508404467538827_);}\n\t.st30{fill:url(#SVGID_00000077296301474801043340000013595895705447846274_);}\n\t.st31{fill:url(#SVGID_00000026867887106226807060000006960621113757655936_);}\n\t.st32{fill:url(#SVGID_00000172415541814600322350000004584723836047343747_);}\n\t.st33{fill:url(#SVGID_00000132785420859684172240000005213206853120627096_);}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M655.1,972.5c-67.1,0-129.6-24.9-181.9-67.7c-35.8-29.3-82.1-29.4-118.1-0.4c-34,27.5-74.5,43.6-117.9,44 C114.6,949.4,14.4,824.3,14.9,670.6c0.2-61.4,16.3-118.1,43.4-163.9C74.9,478.5,83.3,444,81.7,409c-0.1-1.1-0.1-2.2-0.1-3.3 C73.1,194.2,213,19.2,381.6,30.1c52.9,3.4,102.1,24.9,143.5,59.7c37.6,31.5,81.9,47.7,127.1,47.2c0.9,0,1.9,0,2.8,0 c184,0,333.2,187,333.2,417.7S839.1,972.5,655.1,972.5z"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M104.7,364.9c0,60.3,22.3,116.5,60.6,163.5c26.2,32.2,26.3,73.8,0.3,106.1c-24.6,30.6-39,67-39.3,106 c-0.9,110.2,111,200.2,248.4,199.8c54.9-0.1,105.6-14.6,146.6-39c25.2-15,56.1-22.5,87.4-21c1,0,2,0.1,2.9,0.1 c189.1,7.6,345.6-118.1,335.9-269.7c-3.1-47.6-22.3-91.7-53.4-129c-28.2-33.8-42.6-73.6-42.2-114.3c0-0.8,0-1.7,0-2.5 c0-165.4-167.3-299.5-373.6-299.5S104.7,199.5,104.7,364.9z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000170240905338061224820000011197797925073779874_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000170240905338061224820000011197797925073779874_)"
    }
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000118359906779769655800000015837994350107167395_",
    d: "M494.6,997.3c-264.8,0-479.5-214.7-479.5-479.5 S229.8,38.2,494.6,38.2s479.5,214.7,479.5,479.5S759.5,997.3,494.6,997.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000160885391553244831360000006209803624833044150_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000118359906779769655800000015837994350107167395_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000061442719230812273660000011610147036635858827_",
    gradientUnits: "userSpaceOnUse",
    x1: 491.2077,
    y1: 42.5216,
    x2: 494.1879,
    y2: 575.9818
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#233F58"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1B1464"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3A617D"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 38.2,
    style: {
      clipPath: "url(#SVGID_00000160885391553244831360000006209803624833044150_)",
      fill: "url(#SVGID_00000061442719230812273660000011610147036635858827_)"
    },
    width: 957.6,
    height: 956.6
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      opacity: 0.05,
      clipPath: "url(#SVGID_00000160885391553244831360000006209803624833044150_)",
      fill: "#B5DCE5"
    },
    cx: 1082,
    cy: 50.1,
    r: 93.8
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000072961254352948754300000008817408570460981148_",
    gradientUnits: "userSpaceOnUse",
    x1: 251.1423,
    y1: 887.6273,
    x2: 333.0984,
    y2: 342.2463
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#233F58"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0382009,
    style: {
      stopColor: "#1B1464"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3A617D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000160885391553244831360000006209803624833044150_)",
      fill: "url(#SVGID_00000072961254352948754300000008817408570460981148_)"
    },
    d: " M572.2,702V912H-8.6l-23.6-299.8c33.1-47.3,135.6-78.9,198.8-78.9C290.7,533.3,451.6,599.3,572.2,702z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      opacity: 0.05,
      clipPath: "url(#SVGID_00000160885391553244831360000006209803624833044150_)",
      fill: "#B5DCE5"
    },
    cx: 1082,
    cy: 50.1,
    r: 69.6
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000035508240980216399980000007274402043534123915_",
    gradientUnits: "userSpaceOnUse",
    x1: 594.2152,
    y1: 959.985,
    x2: 528.6503,
    y2: 490.5997
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#233F58"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0382009,
    style: {
      stopColor: "#1B1464"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3A617D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000160885391553244831360000006209803624833044150_)",
      fill: "url(#SVGID_00000035508240980216399980000007274402043534123915_)"
    },
    d: " M811.1,588.3C573.2,579,295.2,685.8,96.3,788.5v209.9h957.6V647.6C988.4,615.6,908.3,592.1,811.1,588.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      opacity: 0.05,
      clipPath: "url(#SVGID_00000160885391553244831360000006209803624833044150_)",
      fill: "#B5DCE5"
    },
    cx: 1082,
    cy: 50.1,
    r: 49.9
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000160885391553244831360000006209803624833044150_)"
    }
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000159456689909275069450000001836207412011853479_",
    cx: 1083.1274,
    cy: 49.4626,
    r: 68.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00175383,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9989,
    style: {
      stopColor: "#B5DCE5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000159456689909275069450000001836207412011853479_)"
    },
    d: "M1088.7,0.8c-0.6-0.1-1.2-0.1-1.8-0.2 c13.6,10.5,21.4,27.7,19.1,45.9c-3.5,26.7-27.5,45.7-54.1,43.2c6.8,5.2,14.9,8.8,24,9.9c27.3,3.5,52.3-15.7,55.9-43 S1116,4.3,1088.7,0.8z"
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 738.1,
    cy: 275.2,
    r: 8.4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 273.3,
    cy: 480.6,
    r: 8.4
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 120.6,
    cy: 475.9,
    r: 8.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M368.2,173c0,2.9-2.4,5.3-5.3,5.3c-2.9,0-5.3-2.4-5.3-5.3c0-2.9,2.4-5.3,5.3-5.3 C365.9,167.7,368.2,170,368.2,173z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M252.7,256.8c0,2.6-2.1,4.7-4.7,4.7c-2.6,0-4.7-2.1-4.7-4.7c0-2.6,2.1-4.7,4.7-4.7 C250.6,252,252.7,254.2,252.7,256.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M781.9,379.1c0,2.3,1.9,4.2,4.2,4.2c2.3,0,4.2-1.9,4.2-4.2c0-2.3-1.9-4.2-4.2-4.2 C783.8,374.9,781.9,376.8,781.9,379.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M626.9,127.4c0,1.8,1.5,3.3,3.3,3.3s3.3-1.5,3.3-3.3c0-1.8-1.5-3.3-3.3-3.3S626.9,125.6,626.9,127.4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M414.7,100.5c0,1.8,1.5,3.3,3.3,3.3c1.8,0,3.3-1.5,3.3-3.3s-1.5-3.3-3.3-3.3 C416.2,97.1,414.7,98.6,414.7,100.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M152,362.3c0,2.3,1.9,4.2,4.2,4.2c2.3,0,4.2-1.9,4.2-4.2c0-2.3-1.9-4.2-4.2-4.2 C153.9,358,152,359.9,152,362.3z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M156.1,267.5c0,2.2-1.8,3.9-3.9,3.9c-2.2,0-3.9-1.8-3.9-3.9c0-2.2,1.8-3.9,3.9-3.9 C154.4,263.6,156.1,265.3,156.1,267.5z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M755.7,203.5c0,2.2-1.8,3.9-3.9,3.9c-2.2,0-3.9-1.8-3.9-3.9c0-2.2,1.8-3.9,3.9-3.9 C753.9,199.6,755.7,201.3,755.7,203.5z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M290.9,153c0,2.2-1.8,3.9-3.9,3.9c-2.2,0-3.9-1.8-3.9-3.9c0-2.2,1.8-3.9,3.9-3.9 C289.1,149.1,290.9,150.8,290.9,153z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M573.1,123.3c0,3.8-3.1,6.9-6.9,6.9c-3.8,0-6.9-3.1-6.9-6.9s3.1-6.9,6.9-6.9 C570,116.4,573.1,119.5,573.1,123.3z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 783.8,
    cy: 549.3,
    r: 5.3
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 804,
    cy: 303.5,
    r: 5.3
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 164.1,
    cy: 451.7,
    r: 5.3
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M837,470c0,3.1,2.5,5.6,5.6,5.6s5.6-2.5,5.6-5.6c0-3.1-2.5-5.6-5.6-5.6S837,466.9,837,470z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M720.4,479c0,3.1,2.5,5.6,5.6,5.6c3.1,0,5.6-2.5,5.6-5.6c0-3.1-2.5-5.6-5.6-5.6 C722.9,473.5,720.4,476,720.4,479z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000007407206119163701770000008762787098379445395_",
    gradientUnits: "userSpaceOnUse",
    x1: 191.4364,
    y1: 405.204,
    x2: 804.9636,
    y2: 405.204
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A26B2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#B6802E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#E3AB2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#FFF6AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#DDA62C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#B0742A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#9C5B27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#F2BA2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF1B5"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      clipPath: "url(#SVGID_00000170240905338061224820000011197797925073779874_)",
      fill: "none",
      stroke: "url(#SVGID_00000007407206119163701770000008762787098379445395_)",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    cx: 498.2,
    cy: 405.2,
    r: 306.5
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000043448283886224512010000001931834495989514159_",
    gradientUnits: "userSpaceOnUse",
    x1: 208.2778,
    y1: 405.204,
    x2: 788.1222,
    y2: 405.204
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A26B2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#B6802E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#E3AB2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#FFF6AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#DDA62C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#B0742A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#9C5B27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#F2BA2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF1B5"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      clipPath: "url(#SVGID_00000170240905338061224820000011197797925073779874_)",
      fill: "none",
      stroke: "url(#SVGID_00000043448283886224512010000001931834495989514159_)",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    cx: 498.2,
    cy: 405.2,
    r: 289.7
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000015334110818486353180000002709672767243421571_",
    gradientUnits: "userSpaceOnUse",
    x1: 225.1192,
    y1: 405.204,
    x2: 771.2808,
    y2: 405.204
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A26B2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#B6802E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#E3AB2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#FFF6AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#DDA62C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#B0742A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#9C5B27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#F2BA2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF1B5"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      clipPath: "url(#SVGID_00000170240905338061224820000011197797925073779874_)",
      fill: "none",
      stroke: "url(#SVGID_00000015334110818486353180000002709672767243421571_)",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    cx: 498.2,
    cy: 405.2,
    r: 272.8
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000022537665846143858680000009576541700142805122_",
    gradientUnits: "userSpaceOnUse",
    x1: 241.9606,
    y1: 405.204,
    x2: 754.4393,
    y2: 405.204
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A26B2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#B6802E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#E3AB2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#FFF6AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#DDA62C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#B0742A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#9C5B27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#F2BA2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF1B5"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      clipPath: "url(#SVGID_00000170240905338061224820000011197797925073779874_)",
      fill: "none",
      stroke: "url(#SVGID_00000022537665846143858680000009576541700142805122_)",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    cx: 498.2,
    cy: 405.2,
    r: 256
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000091002603238592765110000007834570900808096417_",
    gradientUnits: "userSpaceOnUse",
    x1: 258.802,
    y1: 405.204,
    x2: 737.598,
    y2: 405.204
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A26B2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#B6802E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#E3AB2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#FFF6AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#DDA62C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#B0742A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#9C5B27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#F2BA2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF1B5"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      clipPath: "url(#SVGID_00000170240905338061224820000011197797925073779874_)",
      fill: "none",
      stroke: "url(#SVGID_00000091002603238592765110000007834570900808096417_)",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    cx: 498.2,
    cy: 405.2,
    r: 239.1
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000114056719780091875190000012834465768535444107_",
    gradientUnits: "userSpaceOnUse",
    x1: 275.6434,
    y1: 405.204,
    x2: 720.7565,
    y2: 405.204
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A26B2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#B6802E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#E3AB2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#FFF6AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#DDA62C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#B0742A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#9C5B27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#F2BA2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF1B5"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      clipPath: "url(#SVGID_00000170240905338061224820000011197797925073779874_)",
      fill: "none",
      stroke: "url(#SVGID_00000114056719780091875190000012834465768535444107_)",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    cx: 498.2,
    cy: 405.2,
    r: 222.3
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181045957141203565690000015434854735684282261_",
    gradientUnits: "userSpaceOnUse",
    x1: 292.4848,
    y1: 405.204,
    x2: 703.9152,
    y2: 405.204
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A26B2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#B6802E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#E3AB2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#FFF6AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#DDA62C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#B0742A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#9C5B27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#F2BA2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF1B5"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      clipPath: "url(#SVGID_00000170240905338061224820000011197797925073779874_)",
      fill: "none",
      stroke: "url(#SVGID_00000181045957141203565690000015434854735684282261_)",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    cx: 498.2,
    cy: 405.2,
    r: 205.5
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000097486856530751253980000003375172021679191469_",
    gradientUnits: "userSpaceOnUse",
    x1: 309.3263,
    y1: 405.204,
    x2: 687.0737,
    y2: 405.204
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A26B2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#B6802E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#E3AB2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#FFF6AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#DDA62C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#B0742A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#9C5B27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#F2BA2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF1B5"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      clipPath: "url(#SVGID_00000170240905338061224820000011197797925073779874_)",
      fill: "none",
      stroke: "url(#SVGID_00000097486856530751253980000003375172021679191469_)",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    cx: 498.2,
    cy: 405.2,
    r: 188.6
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000170240905338061224820000011197797925073779874_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000177482797931545000490000013062145144641341626_",
    gradientUnits: "userSpaceOnUse",
    x1: 455.5471,
    y1: 141.9169,
    x2: 506.2819,
    y2: 141.9169
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A26B2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#B6802E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#E3AB2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#FFF6AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#DDA62C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#B0742A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#9C5B27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#F2BA2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF1B5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000177482797931545000490000013062145144641341626_)"
    },
    d: "M471.1,137.8c4.7-2.8,10.6-6.3,18.6-6.3 c3.3,0,7.3,0,10.9,2.6c7.4,5.5,5.5,17.5,5.4,18.1c-16.8-0.2-33.6-0.5-50.4-0.7C461.2,144.3,467.2,140.1,471.1,137.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070825521909235551830000006865507101555225002_",
    gradientUnits: "userSpaceOnUse",
    x1: 146.205,
    y1: 715.6718,
    x2: 659.479,
    y2: 715.6718
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#42210B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BA7C44"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000070825521909235551830000006865507101555225002_)"
    },
    d: "M659.5,548.7 c-11.1-1.6-31.7-2.6-49.5,9.3c-8,5.4-13.1,11.8-18.6,18.6c-12.8,16.1-18.8,30.6-21.6,37.1c-7.4,16.8-24.5,38-58.7,80.4 c-19.4,24.1-27.9,31.9-27.8,46.4c0,14.5,8.4,22.2,15.9,36c14.9,27.5,12.1,52.7,11.9,81.5c-0.3,32.8,2.8,82.4,15.5,160.8 c-126.8,0-253.5,0-380.3,0c1.1-30.2,4.5-73.2,15.5-123.7c4.2-19.4,8.2-37.8,15.5-58.7c24.7-71.1,69.3-119.8,108.2-160.8 c36.7-38.6,97.2-94.2,101.5-135.8c0.5-4.7,1.3-13-2.6-21.9c-7-15.9-22.6-19-48-36.1c-7.3-4.9-16.6-11.8-26.7-21.1 c20.4-15.5,68.2-46.9,133.5-47.9C529.9,411.3,612.7,464.4,659.5,548.7z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M439.1,755.3c-29.5-25-65.5-23.6-74.5-23.1c-30.6,1.7-51.9,15.6-67.2,26c-41.3,27.9-67.1,76.8-71.2,84.5 c-35.6,67-41.1,133.7-40.5,176c54.4,0,108.8,0,163.1-0.1c-1.2-10.9-4.8-27.4-16.8-41.5c-19-22.3-39.3-16.6-56.4-33.6 c-30.9-30.9-9.7-96.6-6.4-107c4.4-13.6,17.9-55.5,59.8-79.9c11.3-6.6,39.7-23,75.2-14.8c30.1,6.9,47.8,27.6,53.5,35 C454.1,771.1,448.2,763,439.1,755.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M559.2,478.8c-60-51.7-84.5-95.7-111.4-88.3c-19.4,5.3-27.9,33.6-29.3,49.5c-3,33.1,21.4,58.9,40.8,69.6 c16.3,9,32.1,10,32.1,10c19.3,1.3,31.5-6.3,40,0.9c4.3,3.6,4.7,8.5,6.1,16c6.5,33.4,18.6,33.9,19.8,55.1 c0.9,15.5-8.6,37.5-20.7,50.4c-24.5,26.1-56.1,13-97,27.4c-22.8,8.1-52.6,26.1-80.7,70.8c3.6-1.9,9.1-4.4,16.3-5.4 c5.2-0.7,13-0.9,24.7,3c36,11.9,57.5,38.5,57.5,38.5c18.6,23,24,47.7,26.6,59.4c0.7,3.3,1.4,7.1,1.5,7.5 c1.2,8.1,1.2,16.1,3.5,44.9c2.9,37,4.4,56,8.4,77.1c2.4,12.5,6.6,31.1,14.3,53.4c5,0,10,0,15,0c-12.7-78.3-15.7-128-15.5-160.8 c0.2-28.9,3.2-54.1-11.9-81.5c-6.8-12.4-14.4-19.8-14.7-33.6c-0.4-17.4,11.1-29.2,27-48c6.9-8.2,34.1-40.4,53.5-70.6 c20.4-31.8,30.5-59,50.2-67.3c13.6-5.8,27.8-6.3,27.8-6.3c6.5-0.3,11.9,0.3,15.9,1C633.5,535.9,598,512.2,559.2,478.8z"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M331.1,761.6c-5.1,3.2-23.2,14.9-37.3,37.8c-35.7,57.6-13.2,132.7-1.2,172.9c5.9,19.9,12.6,35.9,17.4,46.5 c-41.4,0-82.8,0-124.2,0c-0.6-42.3,4.9-109,40.5-176c29.1-54.7,61.3-77.9,71.2-84.5c15.3-10.3,36.5-24.3,67.2-26 c9-0.5,45-1.9,74.5,23.1c9.1,7.7,15,15.8,18.7,21.5c-7-7.8-23.7-24-50.1-30.2C369.5,737.8,339.1,756.6,331.1,761.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000055688508184044669740000018056519386108120991_",
    gradientUnits: "userSpaceOnUse",
    x1: 258.838,
    y1: 353.444,
    x2: 754.8614,
    y2: 353.444
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#42210B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BA7C44"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000055688508184044669740000018056519386108120991_)"
    },
    d: "M593,169.9 c19.8,11,47.7,35.5,58.2,50.2c4.7,6.6,8.6,13.5,8.6,13.5c1.2,2.1,6.1,11.2,10.5,22.9c13.5,35.9,4.6,47.4,18.6,71.1 c11.7,20,30.9,34,30.9,34c14.7,10.9,28.6,15.5,29.4,26.3c0.5,6.8-4.5,13.6-5.6,15.1c-6.3,8.6-15.1,10.3-14.5,14.2 c0.4,2.5,4.2,4.1,8,5.7c5.6,2.3,8,1.3,10.6,3.6c2.8,2.5,3,6.4,3.1,9.3c0.5,12.2-7.5,23-10.8,27.1c2.2,0.6,7.2,2.2,10.8,7 c5.9,7.6,5.3,19.1,0,24.7c-4.2,4.5-9.4,3.1-10.8,7c-1.7,4.3,4,8.2,7,14.7c5.7,12.7-1,31.5-11.6,40.2c-10.5,8.7-24.6,7.3-34,6.2 c-85.8-10.4-130.3-15.8-145.3-46.4c-3.7-7.6-9.4-24.4-24.7-46.4c-3.7-5.3-7-9.6-9.3-12.4c-6.7-10.8-23.3-33.6-51.6-41.5 c-42.9-12-96.2,14.9-124.6,69.3c-4.4-2.9-91.8-62.5-86.6-160.8c5.1-95.6,93.3-143.2,114.4-154.6 C466.8,119.5,563.5,153.5,593,169.9z"
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M671.8,310.6c1.9-1.1,1.7-5.9,0-9.3c-3.2-6.6-12.5-9.5-18.6-9.3c-22.4,0.8-38.3,45.7-37.1,46.4 c0.6,0.3,5.3-9.9,18.6-21.6c7.8-7,16.3-14.2,24.7-12.4C666,305.9,669.4,312.1,671.8,310.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M703.7,406c0.1,1.3,0.4,5.3,3.6,8c4.3,3.7,10.6,2,11.9,1.6c4.9-1.4,5.2-4.1,11.4-6.2 c0.4-0.1,2.2-0.7,4-2.1c0.7-0.5,3.5-2.7,3-4.2c-0.4-1.3-3.1-1.7-4.9-1.6c-8.2,0.4-9.8,12.2-17.7,12.9c-3.2,0.3-6.9-1.3-9.2-4 C704.5,408.8,703.9,407.1,703.7,406z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M674.4,356.1c-0.4-5.1-1.2-12.5-3.6-21c-1.9-6.8-3.9-11.7-4.5-11.6c-1.1,0.3,7.4,25.4,0.4,29.6 c-0.4,0.3-1,0.5-7.7,0.2c-7.4-0.3-12.4-0.9-12.4-0.8c0,0.1,10.9,1.5,19,2.5C666.5,355.1,673.6,356,674.4,356.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M656.8,352c7.4,0.1,9.8,0.5,14.7-0.3c2.6-0.4,5.7-0.9,9-2.5c6.3-2.9,10.1-8,12.4-12 c-1.1,3.8-5.2,15.3-15.7,19.7c-0.2,0.1-0.4,0.1-0.6,0.2c3.2,1.4,3.8,2.1,3.7,2.5c-0.4,1.6-13.5,0-24-2.3 c-1.1-0.2-14.3-3.2-14.1-4.6C642.1,351.8,648.7,351.9,656.8,352z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M746.3,425.7c0.4,0.2,1,0.6,1.7,1.2c1.5,1.5,2,3.2,2.2,4c1.6,5.8-0.3,13.6-0.3,13.6 c-0.4,1.9-2.1,8.2-7,15c-1.1,1.5-2.1,2.6-2.8,3.5c-1.1-0.3-2.8-0.5-4.9-0.4c-4.6,0.3-7.8,2.5-9.4,3.5 c-3.2,1.9-8.4,3.6-17.2,2.4c9.2-1.1,14.1-4.5,16.9-7.3c7.3-7.4,5.9-16.8,15.7-29.7C743.2,428.8,745.1,426.9,746.3,425.7z"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M257.5,323.2c8.1-93,90.3-141.8,106.4-151.2c3.5-2,6.2-3.5,8-4.5c3.7-2,120.4-59.2,219.5,0c8.6,5.1,20.9,13.4,34.2,26.3 c-46.8,36.4-57.4,64.2-57.9,83.3c-0.2,7.5,1,18.9-4.3,33.9c-6.9,19.4-16.4,20.8-25.7,39.1c-14.3,27.8-5,49-14.8,52.7 c-10.5,3.9-19.5-21-45.5-24.8c-12.7-1.9-29.4,1.1-39.6,11.9c-13.6,14.3-10.9,38.2-8.6,58.7c2.6,23.5,8.7,28.9,4.6,43.5 c-4.6,16.3-16.9,26.3-20.4,29c-10.3,7.8-20.8,10.3-26.2,11.2c-1.2-5.8-3.7-13.9-10-21.3c-6.6-7.9-13.4-11.2-25.9-17 c-7.8-3.6-18.7-9.5-30.1-18.6C278.8,441.6,252.4,382.5,257.5,323.2z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M519.2,411.5c-6.5-19.9-30.2-28.1-32.6-28.9c-2.9-1-31.9-10.1-48.8,7.3c-17.5,18-6.3,48.2-4.6,52.7 c9.9,26.5,33.9,37.2,40.4,40c20.6,9.1,54.1,13.4,64.7-2.3c4.8-7,5.4-18.6,1.1-26.5c-3.8-6.9-8.8-5.9-13.8-13.2 C518.5,430.4,523,422.9,519.2,411.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M511.3,415.6c4.4,6.1,0.6,11.3,2.6,19.9c2.7,11.2,12.5,14.6,10.8,18.6c-1.8,4-12.6,2.6-15.2,2.3 c-10.8-1.4-25.2-7.4-25.1-14.2c0.1-4.5,6.6-4.2,12.3-13.2c5.5-8.6,4.5-16.6,8.4-17.4C508,411,510.9,415,511.3,415.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M478.2,451.8c1.8-1.3-5.2-9.1-2.7-16.1c2.7-7.6,13.4-5.4,18-13.7c4.7-8.6-1.8-20.1-2.2-20.8 c-7.4-12.6-22.6-12.7-23.9-12.7c-11,0.1-20.6,6.9-25.4,15.3c-10.4,18.4,4,41.5,4.5,41.4c0.4-0.1-8.3-17.8-0.8-31.7 c0.7-1.2,5.3-9.5,14.4-11.3c6.5-1.3,15,0.8,16.4,5.4c1.3,4.7-6.2,7.1-9.1,17.7c-0.3,1.1-3,11.4,2.3,19.8 C472.3,449.5,476.9,452.8,478.2,451.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M507.1,470.9c-0.1,1-14.1,2.4-27.8-4c-16.3-7.6-24.9-22.8-24.1-23.6c0.7-0.7,9.6,12,27.8,20.3 C496.5,469.9,507.2,470,507.1,470.9z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000138547930104316085100000013933146683590676125_",
    gradientUnits: "userSpaceOnUse",
    x1: 419.2836,
    y1: 397.1466,
    x2: 454.4525,
    y2: 397.1466
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A26B2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#B6802E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#E3AB2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#FFF6AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#DDA62C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#B0742A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#9C5B27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#F2BA2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF1B5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000138547930104316085100000013933146683590676125_)"
    },
    d: "M428.2,459 c-3.4-6.1-13.8-27.6-6.1-48.8c4.1-11.3,12.7-20.5,14.4-22.2c3.5-3.6,7.3-6.8,11.5-9.5c1.1-0.9,2.7-2.4,3.5-4.7 c1.3-3.6,0.1-6.7-0.4-7.9l0-0.1c-2.1-5.3-3.9-10.7-5.4-16.2c-1.2-4.6-2.2-9.2-3-13.9l2.4-0.4c0.8,4.6,1.7,9.2,2.9,13.7 c1.4,5.4,3.2,10.7,5.3,15.9c0.7,1.5,2.1,5.3,0.5,9.7c-1,2.9-3,4.8-4.4,5.8l-0.1,0c-4,2.6-7.8,5.7-11.1,9.2 c-1.6,1.7-9.9,10.5-13.8,21.3c-7.4,20.2,2.6,40.9,5.9,46.8L428.2,459z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000162320313163115235140000006665262862954306710_",
    gradientUnits: "userSpaceOnUse",
    x1: 468.7011,
    y1: 378.9618,
    x2: 544.1179,
    y2: 378.9618
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A26B2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#B6802E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#E3AB2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#FFF6AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#DDA62C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#B0742A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#9C5B27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#F2BA2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF1B5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000162320313163115235140000006665262862954306710_)"
    },
    d: "M544.1,429.1c0-7-1.5-30.8-18.7-45.5 c-9.1-7.8-21.1-11.6-23.4-12.3c-4.8-1.4-9.7-2.3-14.7-2.6c-1.4-0.2-3.5-0.8-5.4-2.4c-2.9-2.5-3.4-5.8-3.5-7.1l0-0.1 c-0.8-5.6-1.9-11.3-3.3-16.7c-1.2-4.6-2.6-9.1-4.2-13.6l-2.3,0.8c1.6,4.4,3,8.9,4.2,13.4c1.4,5.4,2.5,10.9,3.2,16.4 c0.1,1.6,0.8,5.7,4.3,8.7c2.4,2,4.9,2.7,6.7,3l0.1,0c4.8,0.3,9.6,1.2,14.2,2.5c2.2,0.7,13.8,4.3,22.5,11.8 c16.4,14,17.8,37,17.8,43.7L544.1,429.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000067924666325369876340000007118062506812211134_",
    gradientUnits: "userSpaceOnUse",
    x1: 366.9061,
    y1: 523.1362,
    x2: 624.656,
    y2: 330.3311
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A26B2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#B6802E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#E3AB2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#FFF6AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#DDA62C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#B0742A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#9C5B27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#F2BA2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF1B5"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000067924666325369876340000007118062506812211134_)"
    },
    cx: 484.2,
    cy: 435.4,
    r: 73
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000019672139676317520040000001429251496292000153_",
    gradientUnits: "userSpaceOnUse",
    x1: 333.9915,
    y1: 394.7914,
    x2: 686.503,
    y2: 489.8639
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A26B2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#B6802E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#E3AB2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#FFF6AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#DDA62C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#B0742A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#9C5B27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#F2BA2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF1B5"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000019672139676317520040000001429251496292000153_)"
    },
    cx: 484.3,
    cy: 435.3,
    r: 62
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000071560416570485312280000010417773946271073718_",
    gradientUnits: "userSpaceOnUse",
    x1: 564.2843,
    y1: 389.7143,
    x2: 351.4472,
    y2: 511.0002
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A26B2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#B6802E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#E3AB2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#FFF6AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#DDA62C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#B0742A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#9C5B27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#F2BA2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF1B5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000071560416570485312280000010417773946271073718_)"
    },
    d: "M483.5,498.3c-2.2,0-4.3-0.2-6.5-0.4 c-16.7-2-31.7-10.3-42.1-23.5c-10.4-13.2-15.1-29.7-13.2-46.4c4-34.5,35.4-59.3,69.9-55.3c16.7,2,31.7,10.3,42.1,23.5 c10.4,13.2,15.1,29.7,13.2,46.4C543.1,474.9,515.3,498.8,483.5,498.3z M485,374.4c-30.8-0.4-57.7,22.6-61.3,53.9 c-3.9,33.4,20.1,63.7,53.5,67.6c33.4,3.9,63.7-20.1,67.6-53.5c3.9-33.4-20.1-63.7-53.5-67.6C489.2,374.5,487.1,374.4,485,374.4 z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000120551595907100197240000010347134004150271636_",
    gradientUnits: "userSpaceOnUse",
    x1: 632.6771,
    y1: 356.787,
    x2: 352.6024,
    y2: 504.9424
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A26B2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#B6802E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#E3AB2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#FFF6AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#DDA62C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#B0742A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#9C5B27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#F2BA2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF1B5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000120551595907100197240000010347134004150271636_)"
    },
    d: "M483.6,483c-1.6,0-3.3-0.1-4.9-0.3 c-12.7-1.5-24-7.8-31.9-17.8c-7.9-10-11.4-22.5-10-35.1c1.5-12.7,7.8-24,17.8-31.9c10-7.9,22.5-11.4,35.1-10 c26.1,3.1,44.9,26.8,41.8,52.9l0,0C528.8,465.3,507.8,483.3,483.6,483z M484.8,391.7c-10-0.1-19.6,3.1-27.6,9.4 c-9.1,7.2-14.9,17.6-16.3,29.2c-1.4,11.6,1.9,23,9.1,32.1c7.2,9.1,17.6,14.9,29.2,16.3c23.9,2.8,45.6-14.4,48.4-38.3l0,0 c2.8-23.9-14.4-45.6-38.3-48.4C487.8,391.8,486.3,391.7,484.8,391.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000046332927158490116660000004788633262217885062_",
    gradientUnits: "userSpaceOnUse",
    x1: 248.1946,
    y1: 364.4375,
    x2: 505.9445,
    y2: 171.6325
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A26B2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#B6802E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#E3AB2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#FFF6AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#DDA62C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#B0742A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#9C5B27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#F2BA2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF1B5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000046332927158490116660000004788633262217885062_)"
    },
    d: "M404.6,151.5c-1,1.4-2.7,4.2-2.6,9.4 c0.5,45.4,18.5,117.5,18.5,117.5c1.4,5.6,3.8,15.5,6.7,28.1c14.8-4.2,29.7-8.5,44.5-12.7c-3.2-15.9-4.6-29-5.3-37.7 c0,0-6.2-78.8,25.5-117.4c2.8-3.4,6.1-4.2,6.1-4.2c1-0.3,1.9-0.3,2.6-0.3c-0.6-0.4-1.4-1-2.5-1.5c0,0-2.8-1.4-6.4-1.7 c-32.8-2.5-57.6,5.7-57.6,5.7c-6.8,2.3-15.9,5.8-26.1,11.5C407.1,148.9,405.8,149.9,404.6,151.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116193656434261533720000018320242750891952792_",
    gradientUnits: "userSpaceOnUse",
    x1: 299.2486,
    y1: 432.6888,
    x2: 556.9985,
    y2: 239.8837
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A26B2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#B6802E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#E3AB2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#FFF6AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#DDA62C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#B0742A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#9C5B27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#F2BA2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF1B5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000116193656434261533720000018320242750891952792_)"
    },
    d: "M489.6,328l-60.1,16.6 c-0.4,0.1-0.8-0.1-1-0.5l-10.3-37.4c-0.1-0.4,0.1-0.8,0.5-1l60.1-16.6c0.4-0.1,0.8,0.1,1,0.5l10.3,37.4 C490.2,327.4,490,327.9,489.6,328z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000154385275908669865900000017766501286098513563_",
    gradientUnits: "userSpaceOnUse",
    x1: 429.5999,
    y1: 321.8107,
    x2: 442.1682,
    y2: 321.8107
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A26B2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#B6802E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#E3AB2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#FFF6AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#DDA62C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#B0742A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#9C5B27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#F2BA2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF1B5"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000154385275908669865900000017766501286098513563_)"
    },
    points: "442.2,341.1 440.4,341.6  429.6,302.5 431.4,302  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000120538133115771529000000008013271489620667063_",
    gradientUnits: "userSpaceOnUse",
    x1: 466.4534,
    y1: 311.6532,
    x2: 479.0228,
    y2: 311.6532
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A26B2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#B6802E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#E3AB2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#FFF6AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#DDA62C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#B0742A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#9C5B27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#F2BA2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF1B5"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000120538133115771529000000008013271489620667063_)"
    },
    points: "479,330.9 477.2,331.4  466.5,292.4 468.3,291.9  "
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicalEncountersFinal);
export default __webpack_public_path__ + "static/media/musical_encounters_final.d5e585418498fa25049f137aac4236ee.svg";
export { ForwardRef as ReactComponent };